import cx from 'classnames';
import React, { useRef } from 'react';
import { useId } from '../hooks/use-id.js';
export const FormInputTextarea = ({ className, id, inputRef, name, disabled, readOnly, selectOnFocus, value, variant = 'default', ...rest }) => {
    const uId = useId();
    const htmlId = id || uId;
    const willSelectOnFocus = selectOnFocus !== null && selectOnFocus !== void 0 ? selectOnFocus : readOnly;
    const fallbackRef = useRef(null);
    const ref = inputRef || fallbackRef;
    return (React.createElement("div", { className: cx('tds-form-input', {
            [`tds-form-input--${variant}`]: variant,
            'tds-form-input--readonly': readOnly,
            'tds--disabled': disabled,
        }, className), onClick: (e) => {
            var _a, _b;
            // NOTE: textarea covers the whole input, so they don't need any
            // focus-on-click magic like other default inputs do
            if (!e.target.closest('button, .tds-tooltip-wrapper') &&
                willSelectOnFocus &&
                !((_a = document.getSelection()) === null || _a === void 0 ? void 0 : _a.toString().length)) {
                // Auto-select text within the input when focused
                (_b = ref.current) === null || _b === void 0 ? void 0 : _b.select();
            }
        } },
        React.createElement("textarea", { className: "tds-form-input-textarea", id: htmlId, name: name, readOnly: readOnly, ref: ref, value: value, disabled: disabled, ...rest })));
};
